import { render, staticRenderFns } from "./IssueCategoriesForm.vue?vue&type=template&id=6be896d0&scoped=true"
import script from "./IssueCategoriesForm.vue?vue&type=script&lang=js"
export * from "./IssueCategoriesForm.vue?vue&type=script&lang=js"
import style0 from "./IssueCategoriesForm.vue?vue&type=style&index=0&id=6be896d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be896d0",
  null
  
)

export default component.exports